import { render, staticRenderFns } from "./TradeHistory.vue?vue&type=template&id=1f861fa3&scoped=true"
import script from "./TradeHistory.vue?vue&type=script&lang=js"
export * from "./TradeHistory.vue?vue&type=script&lang=js"
import style0 from "./TradeHistory.vue?vue&type=style&index=0&id=1f861fa3&prod&lang=scss&scoped=true"
import style1 from "./TradeHistory.vue?vue&type=style&index=1&id=1f861fa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f861fa3",
  null
  
)

export default component.exports